import EditGroupContainer from './containers/EditGroupContainer'

export default EditGroupContainer
